// frontend/src/config/image.js
import { API_URL } from './api';

export const getImageUrl = (path) => {
  if (!path) return undefined;
  
  // Si c'est déjà une URL complète
  if (path.startsWith('http')) {
    return path;
  }
  
  // Si c'est un chemin relatif
  return `${API_URL.replace('/api', '')}${path.startsWith('/') ? path : `/${path}`}`;
};

export const getPhotoUrl = (photoPath, timestamp = null) => {
  if (!photoPath) return undefined;
  
  let url = getImageUrl(photoPath);
  
  // Ajouter un timestamp pour éviter le cache
  if (timestamp) {
    url += `?t=${timestamp}`;
  }
  
  return url;
};